import styles from "./topbar.module.css";
import { FiFacebook } from "react-icons/fi";
import { FaPinterestP } from "react-icons/fa6";
import { IoLogoInstagram } from "react-icons/io";
import { PiYoutubeLogo } from "react-icons/pi";
import { BsTelephone } from "react-icons/bs";
import { CiMail } from "react-icons/ci";
import { useEffect, useState } from "react";
const TopBar = () => { 
  const [hideTopBar, setHideTopBar] = useState(false);

useEffect(() => {
  let lastScroll = 0;

  const handleScroll = () => {
    const currentScroll = window.scrollY;

   if (currentScroll > lastScroll && currentScroll > 50) {
  // scrolling down
  setHideTopBar(true);
  document.body.classList.add("topbar-hidden");
} else {
  // scrolling up
  setHideTopBar(false);
  document.body.classList.remove("topbar-hidden");
}

    lastScroll = currentScroll;
  };

  window.addEventListener("scroll", handleScroll);

  return () => {
    window.removeEventListener("scroll", handleScroll);
  };
}, []);
  return (
   <div className={`${styles.banner} ${hideTopBar ? styles.hide : ""}`}>
      <div className={styles.banner__container}>
        <div className={styles.banner__contact}>
          <div className={styles.banner__contact_item}>
            <BsTelephone size={18} />
            <a href="tel:+918019070584">+91 8019070584</a>
          </div>
          <div className={styles.banner__contact_item}>
            <CiMail size={18} />
            <a
              href="https://mail.google.com/mail/?view=cm&fs=1&to=info@vitaura.co.in"
              target="_blank"
              rel="noopener noreferrer"
            >
              info@vitaura.co.in
            </a>
          </div>
        </div>
        <div className={styles.banner__social}>
          <a
            href="https://www.facebook.com/people/Vitauraofficial/61591452373501/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FiFacebook className={styles.banner__social_icon} size={18} />
          </a>
          <a
            href="https://www.instagram.com/vitauraofficial/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoInstagram className={styles.banner__social_icon} size={18} />
          </a>
          <a
            href="https://www.youtube.com/@vitauraofficial"
            target="_blank"
            rel="noopener noreferrer"
          >
            <PiYoutubeLogo className={styles.banner__social_icon} size={18} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
